module.exports = __webpack_public_path__ + "static/img/login_title.38d8cb38.png";